export const SAGA_GET_LOCALIDAD_ENTREGA = 'localidadesEntregaReducer/SAGA_GET_LOCALIDAD_ENTREGA';
export const SAGA_GET_LOCALIDADES_ENTREGA = 'localidadesEntregaReducer/SAGA_GET_LOCALIDADES_ENTREGA';
export const SET_LOCALIDADES_ENTREGA = 'localidadesEntregaReducer/SET_LOCALIDADES_ENTREGA';
export const SAVE_LOCALIDAD_ENTREGA = 'localidadesEntregaReducer/SAVE_LOCALIDAD_ENTREGA';
export const SAGA_ELIMINAR_LOCALIDAD_ENTREGA = 'localidadesEntregaReducer/SAGA_ELIMINAR_LOCALIDAD_ENTREGA';
export const SAGA_GET_LOCALIDAD_ENTREGA_BY_NOMBRE = 'localidadesEntregaReducer/SAGA_GET_LOCALIDAD_ENTREGA_BY_NOMBRE';
export const SAGA_SAVE_LOCALIDAD_ENTREGA = 'localidadesEntregaReducer/SAGA_SAVE_LOCALIDAD_ENTREGA';

export const sagaGetLocalidadEntrega = (idLocalidadEntrega) => ({
    type: SAGA_GET_LOCALIDAD_ENTREGA,
    payload: { idLocalidadEntrega }
});

export const sagaGetLocalidadesEntrega = (nombre) => ({
    type: SAGA_GET_LOCALIDADES_ENTREGA,
    query: nombre,
});

export const setLocalidadesEntrega = (payload) => ({
    type: SET_LOCALIDADES_ENTREGA,
    payload
});

export const saveLocalidadEntrega = (payload) => ({
    type: SAVE_LOCALIDAD_ENTREGA,
    payload
});

export const sagaEliminarLocalidadEntrega = (idLocalidadEntrega) => ({
    type: SAGA_ELIMINAR_LOCALIDAD_ENTREGA,
    payload: { idLocalidadEntrega }
});

export const sagaGetLocalidadEntregaByNombre = (nombre) => ({
    type: SAGA_GET_LOCALIDAD_ENTREGA_BY_NOMBRE,
    payload: { nombre }
});

export const sagaSaveLocalidadEntrega = (payload) => ({
    type: SAGA_SAVE_LOCALIDAD_ENTREGA,
    payload
});